<template>
<div>
  <div style="color:#606266;height:50px;width:100%;background-color:#E4E7ED;text-align:left;font-size:16px;line-height:50px;font-weight:bold;padding-left:10px;">规则设置</div>
  <div style="padding:20px;border-left:1px solid #E4E7ED;border-right:1px solid #E4E7ED;border-bottom:1px solid #E4E7ED;">
    <el-form ref="form" :model="form" :rules="rules" label-width="400px" class="ques_relus">
      <el-form-item label="组织健康度调研是否控制高分">
        <el-tooltip effect="dark" content="是否控制组织健康度调研中的高得分选项，默认不控制。" placement="right">
            <el-switch
            v-model="form.high_score_controller"
            active-color="#409EFF"
            inactive-color="#C0C4CC"
            :disabled="!enable">
            </el-switch>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="组织健康度调研中包含3分及以下结果的最低数量">
        <el-tooltip effect="dark" content="当控制组织健康度调研中的高得分选项时，调研中必须包含一定个数得分3分及以下的选项。" placement="top-start">
          <el-input v-model="form.low_score_num" 
          placeholder="请配置为正整数" 
          :disabled="!form.high_score_controller || !enable">
          </el-input>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="组织健康度调研是否控制连续相同答案数量">
        <el-tooltip effect="dark" content="是否控制组织健康度调研中连续相同答案的选项，默认不控制。" placement="right">
            <el-switch
            v-model="form.continuous_controller"
            active-color="#409EFF"
            inactive-color="#C0C4CC"
            :disabled="!enable">
            </el-switch>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="组织健康度调研最大连续相同结果值">
        <el-tooltip effect="dark" content="当控制组织健康度调研中最大连续相同结果值时，调研中不能出现指定最多连续个数的相同得分选项。" placement="top-start">
          <el-input v-model="form.continuous_num" 
          placeholder="请配置为正整数" 
          :disabled="!form.continuous_controller || !enable">
          </el-input>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="痛点原因分析支持勾选的最大个数">
        <el-tooltip effect="dark" content="痛点原因分析中支持勾选的最大原因数，默认为不限制。" placement="top-start">
          <el-input 
          v-model="form.cause_analysis_maxnum" 
          placeholder="请配置为正整数，配置为空表示不限制" 
          :disabled="!enable">
          </el-input>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="管理痛点献计献策展示前Top几的痛点">
        <el-tooltip effect="dark" content="管理痛点献计献策展示前Top几的痛点，默认展示TOP3的痛点。" placement="top-start">
          <el-input 
          v-model="form.top_n_painspots" 
          placeholder="请配置为正整数，配置为空展示全部痛点，默认值3" 
          :disabled="!enable">
          </el-input>
        </el-tooltip>
      </el-form-item>
    </el-form>
    <div style="margin-top:20px;">
    <!-- <el-button @click="Cancel_config">取消</el-button> -->
    <el-button type="primary" @click="Submit_config" :disabled="!enable">保存</el-button>
    </div>
  </div>
</div>
</template>

<script>
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";
export default {
    created() {
      this.Cancel_config();
    },
    data() {
        return {
          form: {
              high_score_controller: false,
              low_score_num: '',
              continuous_controller: false,
              continuous_num: '',
              cause_analysis_maxnum: '',
              top_n_painspots: 3,
          },
          enable: true,
          rules: {
            // trigger类型为blur的功能是文本框失去焦点才会触发
            // trigger类型为change的功能是文本框在输入内容时触发
            continuous_num: [
              {required: true, message: '请配置为大于等于0的整数！', trigger: 'blur'},
              {type: 'integer', message: '请配置为大于等于0的整数！', trigger: 'blur'},
            ],
          },
          params_info: {},
        }
      },
      props: ['task_id'],
      methods: {
        Cancel_config() {
          // 取消即从服务器获取此前已保存的配置，并覆盖当前的配置
          let params;
          params = {
              'task_id': this.task_id,
          }
          getdata.getListP("getJKConfigs", params)
            .then(resp => {
                if(resp.data.code == 200){
                    // 新建参数时不使用获取的参数更新前端
                    if(resp.data.flag == 1){
                      this.form = resp.data.data;
                      this.enable = resp.data.enable;
                    }                    
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        Submit_config() {
          this.form.task_id = this.task_id;
          postdata.postList("submitJKConfigs", JSON.stringify(this.form))
              .then(resp => {
                if(resp.data.code == 200){
                  this.$message({
                    message: resp.data.message,
                    type: "success",
                  })
                }else{
                  this.$message({
                    message: resp.data.message,
                    type: "error",
                    duration: 6000,
                    // showClose: true,
                  })
                }
              })
              .catch(err => {
                console.log(err);
              })
        }
      }
}
</script>

<style scoped>
.el-table {
    /* font-size: 18px; */
    margin-top: 10px;
}
.el-table /deep/ th.el-table__cell {
    background-color: #f5f7fa;
}
/* ::v-deep .el-input {
    font-size: 18px;
} */
.el-button {
    font-size: 16px;
}
::v-deep .el-table__header {
    font-size: 16px;
}
.ques_relus {
  text-align: left;
}
.ques_relus /deep/ .el-input {
  width: 500px;
}
</style>